import React from "react";
import { Link } from "react-router-dom";
import { Users, Briefcase, ArrowRight, Check } from "lucide-react";
import { useLang } from "../i18n";
import { PageHero } from "../components/PageHero";
import { Reveal, RevealImage } from "../components/Reveal";
import { IMAGES, fleet } from "../lib/data";

const perks = {
  it: ["Interni in pelle", "Wi-Fi a bordo", "Acqua e amenities", "Autista in livrea"],
  en: ["Leather interiors", "On-board Wi-Fi", "Water & amenities", "Uniformed chauffeur"],
};

export default function Fleet() {
  const { t, lang } = useLang();
  return (
    <>
      <PageHero tag={t("fleet.tag")} title={t("fleet.title")} subtitle={t("fleet.subtitle")} image={IMAGES.fleet1} />

      <section className="mx-auto max-w-7xl px-5 py-24 lg:px-8 lg:py-32">
        <div className="space-y-8">
          {fleet.map((f, i) => (
            <Reveal key={f.key} delay={0.05} data-testid={`fleet-card-${f.key}`}
              className="group grid overflow-hidden border border-white/10 bg-matte-surface md:grid-cols-2">
              <RevealImage src={f.image} alt={f[lang].name} className={`h-72 md:h-full ${i % 2 ? "md:order-2" : ""}`} imgClassName="transition-transform duration-700 group-hover:scale-105" />
              <div className="flex flex-col justify-center p-10 lg:p-14">
                <span className="font-body text-[11px] uppercase tracking-[0.25em] text-gold">{f[lang].tag}</span>
                <h3 className="mt-3 font-heading text-4xl text-white">{f[lang].name}</h3>
                <p className="mt-4 font-body text-sm leading-relaxed text-white/55">{f[lang].desc}</p>
                <div className="mt-6 flex gap-8 font-body text-sm text-white/70">
                  <span className="flex items-center gap-2"><Users size={18} className="text-gold" /> {f.seats} {t("common.passengers")}</span>
                  <span className="flex items-center gap-2"><Briefcase size={18} className="text-gold" /> {f.bags} {t("common.luggage")}</span>
                </div>
                <div className="mt-6 grid grid-cols-2 gap-3">
                  {perks[lang].map((p) => (
                    <span key={p} className="flex items-center gap-2 font-body text-xs text-white/50"><Check size={14} className="text-gold" /> {p}</span>
                  ))}
                </div>
                <Link to="/booking" className="mt-8 inline-flex w-fit items-center gap-2 border border-white/20 px-7 py-3 font-body text-xs uppercase tracking-[0.2em] text-white transition-colors hover:border-gold">
                  {t("common.bookNow")} <ArrowRight size={14} />
                </Link>
              </div>
            </Reveal>
          ))}
        </div>
      </section>
    </>
  );
}
